import React, { createContext, useContext, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        show: false,
        message: "",
        variant: "success", // success | danger | warning | info
    });

    const showToast = React.useCallback((message, variant = "success") => {
        setToast({
            show: true,
            message,
            variant,
        });
    }, []);

    const hideToast = React.useCallback(() => {
        setToast((prev) => ({ ...prev, show: false }));
    }, []);

    const value = React.useMemo(() => ({ showToast, hideToast }), [showToast, hideToast]);

    return (
        <ToastContext.Provider value={value}>
            {children}
            <ToastContainer
                position="top-end"
                className="p-3"
                style={{ zIndex: 9999, position: "fixed" }}
            >
                <Toast
                    bg={toast.variant}
                    show={toast.show}
                    delay={3000}
                    autohide
                    onClose={hideToast}
                >
                    <Toast.Body className="text-white fw-bold">{toast.message}</Toast.Body>
                </Toast>
            </ToastContainer>
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be used within a ToastProvider");
    }
    return context;
};
